var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-entry my-1 col col-12 col-lg-6"},[_c('font-awesome-icon',{attrs:{"icon":[_vm.iconVariant, _vm.icon]}}),_vm._v(" "),_c('span',{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }